import React, { Component } from 'react';
import { connect } from "react-redux";
import { Row, Column } from "@sm/helpers/simple-flexbox";
import { Panel } from "react-bootstrap";

import CustomButton from "@sm/components/custom/Button";
import PageHeader from "@sm/components/PageHeader";
import Select from "@sm/components/custom/Select";

import '@assets/css/sandbox.css';
import NotesIcon from '@assets/images/notes.png';

import * as actions from "@sm/actions";
import { crudActions } from "@sm/services/crudActions";

class Notes extends Component {
  state = {
    whiteLabel: "",
    whiteLabels: [],

    uploadClicked: false
  };

  componentDidMount() {
    crudActions.get(`v1/companies/labels`).then(
      (whiteLabels) => {
        if (whiteLabels) {
          this.setState({
            whiteLabels: whiteLabels
          }, () => {
            this.onValueChange(whiteLabels[0]);
          });
        }
      }
    );
  };

  onValueChange = (event) => {
    this.setState({
      whiteLabel: event.value
    });
  };

  onFileChange = (e) => {
    const file = e.target.files.length ? e.target.files[0] : "";
    if (file) {
      const splittedName = file.name.split(".");
      const extension = splittedName[splittedName.length - 1];
      if (extension !== "pdf") {
        this.props.showAlert(true, "error", "Wrong file format.");
      } else {
        this.setState({
          fileUploaded: e.target.files.length ? e.target.files[0] : ""
        });
      }
    }
  };

  onUpload = () => {
    const { fileUploaded, whiteLabel } = this.state;
    this.setState({
      uploadClicked: true
    });

    if (fileUploaded && whiteLabel) {
      const formData = new FormData();
      formData.append("file", fileUploaded);
      crudActions.post(`v1/notes/${whiteLabel}`, formData, {}, true).then(
        () => {
          this.props.showAlert(true, "success", "Notes successfully uploaded.");
          this.setState({
            fileUploaded: "",
            whiteLabel: "",
            uploadClicked: false
          });
        }
      ).catch(
        err => {
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
          }
        }
      );
    }
  };

  render() {
    const { whiteLabels, whiteLabel, uploadClicked, fileUploaded } = this.state;

    return (
      <Row flexGrow={ 1 } className="module sandbox" vertical='start'>
        <Column flexGrow={ 1 }>
          <PageHeader
            title={ 'Integration Notes' }
            img={ NotesIcon }/>
          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    UPLOAD INTEGRATION NOTES
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <div className="panel-content" style={ {overflow: 'unset'} }>
                    <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                      <Column flexGrow={ 1 } vertical='start' alignSelf="center" className="input-column">
                        <label> White Label </label>
                        <Select
                          className={ !whiteLabel && uploadClicked ? 'error-field' : "" }
                          value={ whiteLabel }
                          required={ true }
                          clearable={ false }
                          onChange={ (value) => this.onValueChange(value) }
                          options={ whiteLabels }
                        />
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf="center" className="empty-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf="center" className="empty-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf="center" className="empty-column">
                        <span/>
                      </Column>
                    </Row>
                    <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                      <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="input-column">
                        <label> Upload PDF file </label>

                        <input
                          id="file-upload"
                          type="file" onChange={ (e) => this.onFileChange(e) }
                          accept="application/pdf"/>
                        <label htmlFor="file-upload" className="file-upload">
                          { !fileUploaded ? "No files uploaded yet." : fileUploaded.name}
                          <span className="browse"> Browse... </span>
                        </label>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="input-column">
                        <CustomButton
                          title="Upload"
                          type="submit"
                          onClick={ () => this.onUpload() }
                        />
                      </Column>
                    </Row>
                  </div>
                </Panel.Body>
              </Panel>
            </Column>
          </Row>
        </Column>
      </Row>
    );
  }
};

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default connect(mapStateToProps, actions)(Notes);
